/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(Class) {
	'use strict';

	var DashboardDrillInfoService = Class.extend({

		/**
		 * @param {object} attributes.glassContext - The glassContext associated with this service.
		 */
		init: function(attributes) {
			this._glassContext = attributes.glassContext;
			DashboardDrillInfoService.inherited('init', this, arguments);
		},

		getParameters: function(/** storeId */) {
			// TODO need to be implemented when support drill to dashboard.
			return Promise.resolve();
		}
	});

	return DashboardDrillInfoService;
});
